import React from "react";
import { View, Text, StyleSheet, TouchableOpacity,
	Platform, Dimensions, I18nManager, AsyncStorage, FlatList } from "react-native";

import { format, parse } from 'date-fns'
import { CheckBox } from 'react-native-elements'
import * as firebase from "firebase";
import * as Font from 'expo-font';
import { color } from "../config/color"
import store from "../config/config.json"

import { Ionicons } from "@expo/vector-icons";
import PlaceholderComp from "../utilities/PlaceholderComp";
import Main from "../widgets/Main";
import i18n from 'i18n-js';
import MainComponent from "../utilities/MainComponent";
import AppContext from "../utilities/AppContext"

export default class ScheduleScreen extends MainComponent {	

	static path = "scheduled"
	state = {
		store: {},
		hovered : [],
		timeSetString : "Order Now",
		showLoading: true,
		showSoonAvailability: false,
		customDelivery: false,
		soonAvailability: false,
		showFullMode 	: true,
		scheduleLimit: 1,
		data : [],
		mainData: [],
		calendarData : [],
		selectedData : undefined,
		fakeData : new Array(10).fill({})
	};
	
	static navigationOptions = {
		headerShown: false
	};

	constructor(props) {
		super(props);
		
		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;
		
		this.state.height = screenHeight
		this.state.width = screenWidth
			
		if(screenWidth < color.screenLimit){
			this.state.showFullMode = false;			
		}else{
			this.state.showFullMode = true;			
		}
	}

	changeHoverState(isHovered, key){
		this.state.hovered[key] = isHovered
		this.setState({hovered: this.state.hovered})
	}

	componentDidMount() {	

		this.state.locale = i18n.locale;
		Dimensions.addEventListener('change', (e) => {
			const { width, height } = e.window;
			this.setState({height: height, width: width})
			if(width < color.screenLimit){
				this.setState({showFullMode: false});			
			}else{
				this.setState({showFullMode: true});			
			}
		})

		if(this.context.deliveryData.timings != undefined){
			this.state.selectedData = this.context.deliveryData.timings
		}
		
		this.getDetails()
	}

	getDetails = async () => 
	{
		console.log("Calling")
		try {

            var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
				value = JSON.parse(value)			
            this.setState({store: value})
            
        } catch (error) {
            console.log(error)
        }

		if(!this.state.store.enableDelivery && !this.state.store.soonAvailability && !this.state.store.enableCustomDelivery){
			this.props.navigation.navigate('menu');
			return
		}

		let that = this

		firebase.database().ref('stores/' + store.storeId).once("value", function(snapshot) {			

			let data = snapshot.val()
			this.state.showLoading = false

			if(data != undefined)
			{
				var scheduleLimit = data['scheduleLimit']
				if(scheduleLimit == undefined || scheduleLimit < 1)
					scheduleLimit = 1

				this.state.mainData = data['timings']
				if(this.state.mainData == undefined)
					this.state.mainData = []
				this.state.scheduleLimit = scheduleLimit
	
				if (data['soonAvailability'] != undefined && data['soonAvailability'] == true){

					this.state.showSoonAvailability = true
					if (this.state.selectedData == "" || this.state.selectedData == undefined)
					{
						this.state.timeSetString = "Order Now"
						that.changeOption(true, false, false)
					}
					else
					{
						if(this.state.selectedData.date == "Order Now")
							that.changeOption(true, false, false)
						else if (this.state.selectedData.date == this.state.store.customDeliveryText)
							that.changeOption(false, false, true)
						else
							that.changeOption(false, false, false)
					}
				}
				else
				{
					this.state.showSoonAvailability = false
					// In case the old data has as soon as and its not allowed anymore
					if(this.state.selectedData != "" && this.state.selectedData != undefined && this.state.selectedData == "Order Now")
						this.state.selectedData = ""
					
					if (this.state.selectedData.date == this.state.store.customDeliveryText || this.state.store.customDelivery)
						that.changeOption(false, false, true)
					else
						that.changeOption(false, false, false)					
				}				
			}

			that.setState({showLoading: false})	
			
		}.bind(this), function(error) { 
			console.log(error)
			that.setState({showLoading: false})
		});

		await Font.loadAsync(color.appFonts);
	}

	changeOption(soonAvailability, updateState, customDelivery)
	{
		if(soonAvailability) {
			this.state.customDelivery = false
			this.state.calendarData = []
			this.state.soonAvailability = true;
			this.state.timeSetString = "Order Now"						
		}
		else if (customDelivery)
		{
			this.state.calendarData = []
			this.state.soonAvailability = false;
			this.state.customDelivery = true
			this.state.timeSetString = this.state.store.customDeliveryText				
		}else
		{
			this.state.customDelivery = false
			let calendarData = this.getCalendarData()
			if(calendarData.length > 0)
			{
					var index = 0
					for (var i = 0; i < calendarData.length; i++) 
					{ 
						if(calendarData[i].date == this.state.selectedData.date)
						{
							var mData = []
							index = i
							let time = calendarData[i].data[0].openingTime + " - " + calendarData[i].data[0].closingTime
							var item = undefined
							var mainData = calendarData[i].data
							for (var x = 0; x < mainData.length; x++) 
							{
								let obj = mainData[x]
								let mTime = obj.openingTime + " - " + obj.closingTime

								if (mTime == time){
									item = {openingTime: obj.openingTime, isChecked: true, closingTime: obj.closingTime, day: obj.day}
									mData.push(item)
								}
								else
									mData.push({openingTime: obj.openingTime, isChecked: false, closingTime: obj.closingTime, day: obj.day})			
							}

							calendarData[0].isChecked = false
							calendarData[index].data = mData
							calendarData[index].isChecked = true

							let str = format(parse(calendarData[index].date, 'dd-MM-yyyy', new Date()), 'dd MMM') + " " +  item.openingTime + " - " + item.closingTime
							
							this.state.calendarData = calendarData
							this.state.timeSetString = str
							this.state.selectedIndex = index
							this.state.soonAvailability = soonAvailability
							return
						}
					}

					if(calendarData.length > 0)
					{
						let str = format(parse(calendarData[0].date, 'dd-MM-yyyy', new Date()), 'dd MMM') + " " + calendarData[0].data[0].openingTime + " - " + calendarData[0].data[0].closingTime
						this.state.calendarData = calendarData
						this.state.timeSetString = str
						this.state.selectedIndex = index
						this.state.soonAvailability = soonAvailability
					}				
			}
		}

		if(updateState){
			this.setState({showLoading: false})
		}
	}

	getCalendarData(){

		var i, mData = [];
		var date = new Date()

		for (i = 0; i < this.state.scheduleLimit; i++) 
		{ 
			var tomorrow = new Date();
			tomorrow.setDate(date.getDate() + i);
			let day = tomorrow.getDay()

			var title = format(tomorrow, 'dd MMM');
			var subTitle = ""	
			if(i == 0)
				subTitle = i18n.t("today")
			else if (i == 1)
				subTitle = i18n.t("tomorrow")
			else
				subTitle = format(tomorrow, 'EEEE');

			var data = []
			for (var x = 0; x < this.state.mainData.length; x++) 
			{
				let obj = this.state.mainData[x]
				if (obj.day == day || obj.day == -1){
					data.push({openingTime: obj.openingTime, isChecked: data.length == 0 ? true:false, closingTime: obj.closingTime, day: obj.day})
				}
			}
			
			if(data.length > 0)
			{
				mData.push({date: format(tomorrow, 'dd-MM-yyyy'), data: data,
						title: title, subTitle: subTitle, 
						isChecked: i == 0 ? true : false})
			}
		}

		return mData
	}

	backBtnPressed(){
		this.props.navigation.goBack(null)		
	}

	listRowCalendarPressed(item, index){

		var data = []
		for (var i = 0; i < this.state.calendarData.length; i++) 
		{ 
			let obj = this.state.calendarData[i]
			if(i == index)
				obj.isChecked = true
			else
				obj.isChecked = false

			data.push(obj)
		}

		let str = format(parse(data[index].date, 'dd-MM-yyyy', new Date()), 'dd MMM') + " " + data[index].data[0].openingTime + " - " + data[index].data[0].closingTime
		this.setState({calendarData: data, timeSetString: str, selectedIndex: index})
	}

	selectTime(item){

		this.state.calendarData = this.getCalendarData()
		item.isChecked = !item.isChecked
		let time = item.openingTime + " - " + item.closingTime

		var mData = []
		var mainData = this.state.calendarData[this.state.selectedIndex].data
		for (var x = 0; x < mainData.length; x++) 
		{
			let obj = mainData[x]
			let mTime = obj.openingTime + " - " + obj.closingTime

			if (mTime == time)
				mData.push({openingTime: obj.openingTime, isChecked: true, closingTime: obj.closingTime, day: obj.day})
			else
				mData.push({openingTime: obj.openingTime, isChecked: false, closingTime: obj.closingTime, day: obj.day})			
		}

		let calendarData = this.state.calendarData
		calendarData[this.state.selectedIndex].data = mData

		let str = format(parse(this.state.calendarData[this.state.selectedIndex].date, 'dd-MM-yyyy', new Date()), 'dd MMM') + " " +  item.openingTime + " - " + item.closingTime
		this.state.calendarData = calendarData;
		this.state.timeSetString = str;

		this.setState({showLoading: false})	
	}

	finalizeTime(){		

		if(this.state.soonAvailability || this.state.customDelivery)
		{
			var data = {area: this.context.deliveryData.area, timings : {date: "Order Now"}}
			if (this.state.customDelivery)
				data = {area: this.context.deliveryData.area, timings : {date: this.state.store.customDeliveryText}}
			
			var updateFunc = this.context.onUpdate
			this.context.deliveryData = (data)
			if(this.context.goBack)	{
				this.context.goBack = false;
				this.props.navigation.goBack(null)
			}else
				this.props.navigation.navigate('menu');
			if(updateFunc != undefined)
				updateFunc(data)
		}
		else{
			var mData = undefined
			this.state.calendarData[this.state.selectedIndex].data.map(obj => {
				if(obj.isChecked){
					mData = obj
				}
			})

			let calendarData = this.state.calendarData[this.state.selectedIndex]
			calendarData.data = mData
			if(mData != undefined)
			{
				var updateFunc = this.context.onUpdate
				let data = {area: this.context.deliveryData.area, timings : calendarData}
				console.log(calendarData)
				this.context.deliveryData = (data)		
				if(this.context.goBack)	{
					this.context.goBack = false;
					this.props.navigation.goBack(null)
				}else
					this.props.navigation.navigate('menu');
	
				if(updateFunc != undefined)
					updateFunc(data)
			}
		}
	}

	/****
	 * 
	 * 
	 * 
	 * 
	 * 
	 */

	renderListItem = ({ item }) => 
	{		
		var title = item.openingTime + " - " + item.closingTime
		return (
			<View 
			>
				<View  style={{height: 55}}>

					<View  style={{ flexDirection: "row", height: 55, alignContent: "center", alignItems:"center"}}>
							<View style={{marginLeft: 8}}>
							<CheckBox
								textStyle={{fontFamily: 'main-regular', color: 'black', textAlign: "center", fontSize: 16 }}
								containerStyle={{marginLeft: 25, backgroundColor: 'rgba(0, 0, 0, 0)', borderWidth: 0}}
								title={title}
								checkedIcon='dot-circle-o'
								uncheckedIcon='circle-o'
								checkedColor = {this.state.store.primaryColor}
								checked={item.isChecked}
								onPress={() => this.selectTime(item) }
								checkedColor={this.state.store.primaryColor}
								uncheckedColor={this.state.hovered[title] ? this.state.store.primaryColor : color.lightGray}
								onMouseEnter={() => 
									this.changeHoverState(true, title)
								}
								onMouseLeave={() => this.changeHoverState(false, title)}
							/>
							</View>
					</View>
				</View>
			</View>
		);
	}
	
	renderCalendarItem = ({ item, index }) => 
	{		
		let isChecked = item.isChecked
		var mainColor = 'white'
		if(isChecked){
			mainColor = color.bigSeparator
		}

		if(this.selectedData == undefined){
			this.selectedData = {date: ""}
		}

		return (
			<View style={{width: 95, height: 75, backgroundColor: mainColor,  flexDirection:"row", 
					borderBottomWidth: 2, borderBottomColor: color.bigSeparator, borderTopWidth: 2, borderTopColor: color.bigSeparator

				}}>
				<View style={{width: 2, height:75, justifyContent: "center"}}/>
				<TouchableOpacity style={{width: 94, justifyContent: "center", alignItems:"center", alignContent:"center", height:75}} onPress={() => 
						{ this.listRowCalendarPressed(item, index) 
				}}
				>
					{ this.state.selectedData.date == item.date && (
						<View style={{width: 94, justifyContent: "center", alignItems: "center", alignContent: "center", flex:1}}>
							<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, textAlign: "center", fontSize: 15 }}>{item.title.toUpperCase()}</Text>
							<Text style={{ fontFamily: 'main-bold', color: "black", marginTop: 0, textAlign: "center", fontSize: 15 }}>{item.subTitle}</Text>
						</View>
					)}

					{ this.state.selectedData.date != item.date && (
						<View style={{justifyContent: "center", alignItems: "center", alignContent: "center", flex:1}}>
							<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, textAlign: "center", fontSize: 15 }}>{item.title.toUpperCase()}</Text>
							<Text style={{ fontFamily: 'main-bold', color: "black", marginTop: 0, textAlign: "center", fontSize: 15 }}>{item.subTitle}</Text>
						</View>
					)}	

				</TouchableOpacity>
			</View>
		);
	}
	
	// List View 
	renderDetails(marginTop){

		var mTimeString = this.state.timeSetString;
		if(mTimeString == "Order Now")
			mTimeString = i18n.t('orderNow')

		var data = []
		if (this.state.calendarData.length > this.state.selectedIndex)
			data = this.state.calendarData[this.state.selectedIndex].data

		var shouldDisable = false
		var opacity = 1
		if(this.state.store.status == false)
		{
			shouldDisable = true
			opacity = .5
		}	

		return (
			<View style={{flex:1, backgroundColor: 'white'}}>
			
				<View style={{height: 1, marginTop: marginTop, backgroundColor:color.bigSeparator, justifyContent: "center"}}/>

				{ this.state.showSoonAvailability && ( <CheckBox
					key={'first'}
					checkedColor={this.state.store.primaryColor}
					uncheckedColor={this.state.hovered['first'] ? this.state.store.primaryColor : color.lightGray}
					onMouseEnter={() => 
						this.changeHoverState(true, 'first')
					}
					onMouseLeave={() => this.changeHoverState(false, 'first')}
					title={i18n.t("orderNow")}
					checkedIcon='dot-circle-o'
					uncheckedIcon='circle-o'
					checkedColor = {this.state.store.primaryColor}
					containerStyle={{marginLeft: 15, backgroundColor: 'rgba(0, 0, 0, 0)', borderWidth: 0}}
					checked={this.state.soonAvailability}
					onPress={() => { 							
						this.changeOption(true, true, false)
						}}
				/>	)}	

				{ this.state.store.enableCustomDelivery && ( <CheckBox
					key={'third'}
					checkedColor={this.state.store.primaryColor}
					uncheckedColor={this.state.hovered['third'] ? this.state.store.primaryColor : color.lightGray}
					onMouseEnter={() => 
						this.changeHoverState(true, 'third')
					}
					onMouseLeave={() => this.changeHoverState(false, 'third')}
					title={this.state.store.customDeliveryText}
					checkedIcon='dot-circle-o'
					uncheckedIcon='circle-o'
					checkedColor = {this.state.store.primaryColor}
					containerStyle={{marginLeft: 15, backgroundColor: 'rgba(0, 0, 0, 0)', borderWidth: 0}}
					checked={this.state.customDelivery}
					onPress={() => { 							
						this.changeOption(false, true, true)
						}}
				/>	)}	



				{ this.state.mainData.length > 0 && ( <CheckBox
								key={"second"}
								checkedColor={this.state.store.primaryColor}
								uncheckedColor={this.state.hovered['second'] ? this.state.store.primaryColor : color.lightGray}
								onMouseEnter={() => 
									this.changeHoverState(true, 'second')
								}
						        onMouseLeave={() => this.changeHoverState(false, 'second')}
					containerStyle={{marginLeft: 15, backgroundColor: 'rgba(0, 0, 0, 0)', borderWidth: 0}}
					title={i18n.t("scheduleOrder")}
					checkedIcon='dot-circle-o'
					uncheckedIcon='circle-o'
					checkedColor = {this.state.store.primaryColor}
					checked={(!this.state.soonAvailability && !this.state.customDelivery)}
					onPress={() => { 							
						this.changeOption(false, true, false)
						}}
				/>	)}	

				{!this.state.showLoading && this.state.soonAvailability == false && (

					<View style={{flex: 1}}>
												
						<View style={{height: 75}}>
							<FlatList
								extraData={this.state.selectedData}
								horizontal={true}
								data={this.state.calendarData}
								renderItem={this.renderCalendarItem}
								keyExtractor={item => item.title}
							/>
						</View>

						<FlatList
							style={{marginTop: 15}}
							showsHorizontalScrollIndicator={false}
							data={data}
							renderItem={this.renderListItem}
							keyExtractor={item => item.openingTime + " - " + item.closingTime}
						/>
					</View>
				)}
				
				{this.state.showLoading && (
					this.state.fakeData.map((e, i) => <PlaceholderComp key={i} />)
				)}

				{shouldDisable && (
				<View style={{height: 64, justifyContent: "center", marginTop: "auto"}}>											
						<TouchableOpacity disabled={shouldDisable} style={{opacity: opacity, marginLeft: 10, marginRight: 10, marginBottom: 8, marginTop: "auto", height:48, justifyContent: "center"}}
								>
							<View style={{flexDirection: "row", justifyContent: "center", alignItems: "center", flex:1, borderRadius: store.buttonCorner, backgroundColor:this.state.store.primaryColor}}>
							<Text style={{ fontFamily: 'main-bold',position: "absolute", marginLeft: "auto", marginRight: "auto", color:'#FFF', fontSize:14}}>{i18n.t("tempClosed")}</Text>
							</View>
						</TouchableOpacity>
				</View>
				)}
				{!shouldDisable && (
				<View style={{height: 64, justifyContent: "center", marginTop: "auto"}}>											
						<TouchableOpacity style={{marginLeft: 10, marginRight: 10, marginBottom: 8, marginTop: "auto", height:48, justifyContent: "center"}}
									onPress={() => { this.finalizeTime() }}
								>
							<View style={{flexDirection: "row", justifyContent: "center", alignItems: "center", flex:1, borderRadius: store.buttonCorner, backgroundColor:this.state.store.primaryColor}}>
							<Text style={{ fontFamily: 'main-bold',position: "absolute", marginLeft: "auto", marginRight: "auto", color:'#FFF', fontSize:14}}>{i18n.t('setTime')} • {mTimeString}</Text>
							</View>
						</TouchableOpacity>
				</View>
				)}
				
			</View>
		)
	}

	render() {
		
		var icoName = "ios-arrow-back"
		if(I18nManager.isRTL)
			icoName = "ios-arrow-forward"

		if(this.state.locale != i18n.locale){
			this.state.locale = i18n.locale
			this.changeOption(this.state.soonAvailability, false, false)
		}

		var that = this
		return (
			<AppContext.Consumer>
			{ (context) => (
				<View style={styles.container} ref={(ref) => { 
					this.context = context; 					
				}}>
					{this.state.showFullMode && (										
						
						<View style={styles.webContainer}>						
							
							<View style={{backgroundColor: color.backgroundColor, height: this.state.height, width: this.state.width * .33}}>

								{that.renderDetails(50)}

								<View style={styles.topBar}>															
									<View style={{width: '100%', position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
										<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}>{i18n.t('orderMode')}</Text>																						
									</View>	
									<TouchableOpacity style={{height:40, width: 40, justifyContent: "center", alignItems:"center"}}
											onPress={() => { this.props.navigation.goBack(null) }} >
											<Ionicons name={icoName} size={24} color={'black'} />
									</TouchableOpacity>		
								</View>

							</View>

							<Main {...this.state} changeMenu={this.changeMenu} />

						</View>					
					)}
					
					{!this.state.showFullMode && !this.state.showMenu && (
						<View style={styles.container}>						
													
							<View style={{backgroundColor: color.backgroundColor, height: this.state.height, flex: 1}}>
								{that.renderDetails(50)}
							</View>

							<View style={styles.topBar}>	
								<View style={{flex: 1, width: "100%", position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
									<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}>{i18n.t('orderMode')}</Text>																						
								</View>	
								<TouchableOpacity style={{height:40, width: 40, justifyContent: "center", alignItems:"center"}}
										onPress={() => { this.props.navigation.goBack(null) }} >
										<Ionicons name={icoName} size={24} color={'black'} />
								</TouchableOpacity>													
							</View>
							
						</View>
					)}
					
				</View>
		)}
		</AppContext.Consumer>
	)}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: 'white'
	},
	webContainer: {
		flex: 1,
		flexDirection: "row",
	},
	topBar: {
		backgroundColor: "white",
        position: "absolute",
        width: "100%", 
        height: 50,
		flexDirection: "row", 
        alignContent: "center", 
        alignItems: "center"
    }
});
